import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AboutComponent } from './pages/about/about.component';
import { CommercialComponent } from './pages/commercial/commercial.component';
import { ContactComponent } from './pages/contact/contact.component';
import { FooterComponent } from './components/footer/footer.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { HeaderComponent } from './components/header/header.component';
import { HoldingsComponent } from './pages/holdings/holdings.component';
import { HomeComponent } from './pages/home/home.component';
import { HostingComponent } from './pages/hosting/hosting.component';
import { LoginComponent } from './pages/login/login.component';
import { PartnershipsComponent } from './pages/partnerships/partnerships.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { RegisterComponent } from './pages/register/register.component';
import { RetailComponent } from './pages/retail/retail.component';
import { TransportationComponent } from './pages/transportation/transportation.component';
import { ValidationComponent } from './components/validation/validation.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    AboutComponent,
    CommercialComponent,
    TransportationComponent,
    ContactComponent,
    HostingComponent,
    PricingComponent,
    RetailComponent,
    ValidationComponent,
    HoldingsComponent,
    PartnershipsComponent,
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent
  ],
  imports: [BrowserModule, AppRoutingModule, ReactiveFormsModule, HttpClientModule],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
